import { render } from "./PeopleSection.vue?vue&type=template&id=1efc0656&scoped=true"
import script from "./PeopleSection.vue?vue&type=script&lang=js"
export * from "./PeopleSection.vue?vue&type=script&lang=js"

import "./PeopleSection.vue?vue&type=style&index=0&id=1efc0656&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1efc0656"]])

export default __exports__